/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

/* Check Viewport */
 var Viewport = {};
 Viewport.documentWidth = function(){
   var e = window, a = 'inner';
   if (!('innerWidth' in window )) {
 	a = 'client';
 	e = document.documentElement || document.body;
   }
   return { width : e[ a+'Width' ] , height : e[ a+'Height' ] };
 };

 var e = {};
 var etype = e.type;
 function keydownClick(){

 	if( etype === 'keydown' && (e.keyCode !== 13 || e.keyCode !== 32) ) {
 		 return true;
 	}
 }


(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {

		// hero banner full height
        if ( $( '.hero-banner' ).length > 0 ) {
        	$( '.hero-banner' ).parents( 'html' ).addClass( 'full-banner' );
        }

		// vfb form
		$( '.vfb-checkbox label' ).addClass( 'checkbox-label' );
		$( '.vfb-radio' ).addClass( 'radio-label' );
    $( '.vfb-checkbox label' ).append( '<span class="checkmark"><svg viewBox="0 0 20 16" preserveAspectRatio="xMidYMid meet" aria-hidden="true"><use xlink:href="#icon--check" /></svg></span>' );
    $( '.vfb-radio label' ).append( '<span class="checkmark"></span>' );
		$( '.contact-through' ).parents( '.vfb-form-group' ).addClass( 'vfb-col-6' );
		$( '.terms' ).parents( '.vfb-checkbox' ).addClass( 'agreement' );
		$( '.vfbp-form .btn-primary' ).attr( 'disabled', true );
		$( '.vfb-clearfix' ).remove();

		$( '.terms' ).on( 'change', function(){
			if ( $( '.terms' ).is( ':checked' ) ) {
				$( '.vfbp-form .btn-primary' ).attr( 'disabled', false );
			}else{
				$( '.vfbp-form .btn-primary' ).attr( 'disabled', true );
			}
		});

		$( '.checkbox-label' ).each( function(){
			if ( $( this ).find( 'em' ).length > 0 ) {
				$( this ).parent( '.vfb-checkbox' ).addClass( 'has-description' );
			}
		});

		$( '.vfb-form-group' ).on( 'change keyup keydown paste cut', 'textarea', function (){
		    $( this ).height(0).height( this.scrollHeight );
		}).find( 'textarea' ).change();

		// Single Ponty
		$( window ).on( 'load', function(){
			$( '.pnty-btn' ).wrap( '<div class="btn-center"></div>' );
		});

		// tabs
		if ( $( '.header-info__tabs li' ).length === 2 ) {
			$( '.header-info__tabs' ).addClass( 'is-2-tab' );
		}

		if ( $( '.header-info__tabs li' ).length === 3 ) {
			$( '.header-info__tabs' ).addClass( 'is-3-tab' );
		}

		if ( $( '.header-info__tabs li' ).length === 4 ) {
			$( '.header-info__tabs' ).addClass( 'is-4-tab' );
		}

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');

      var lazyLoadInstance = new LazyLoad({
          threshold: 500,
          elements_selector: '.lazy',
          use_native: true,
      });

      if (lazyLoadInstance) {
          lazyLoadInstance.update();
      }

      window.lazyLoadInstance = lazyLoadInstance;

      //https://michalsnik.github.io/aos/
    
        AOS.init({
          startEvent: 'load',
          offset: 50,
          easing: 'ease-in',
          duration: 800
      });
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
